/* WHICH MODEL DO I HAVE? - the dialog next to the device selector.
   Delegated, so it works for however many product forms a page renders and
   survives a section re-render without rebinding. */
(function () {
  "use strict";

  var openPanel = null;
  var lastFocus = null;
  var prevBodyOverflow = null;

  function focusables(root) {
    return [].slice
      .call(root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
  }

  function open(wrap, trigger) {
    if (!wrap || openPanel) return;

    /* The dialog is authored inside the product form, but it is position:fixed.
       A transform, filter or backdrop-filter on ANY ancestor makes a fixed
       descendant resolve against that ancestor instead of the viewport, and
       the form sits inside several blurred panels - the same containing-block
       trap the popovers on this page already hit. Reparenting to body on first
       open removes the question entirely. */
    if (wrap.parentElement !== document.body) document.body.appendChild(wrap);

    openPanel = wrap;
    lastFocus = trigger || document.activeElement;
    wrap.hidden = false;
    /* forces a frame so the transition has a start state to run from */
    wrap.getBoundingClientRect();
    wrap.classList.add("is-open");

    prevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    var f = focusables(wrap);
    if (f.length) f[0].focus();
  }

  function close() {
    if (!openPanel) return;
    var wrap = openPanel;
    openPanel = null;
    wrap.classList.remove("is-open");

    document.body.style.overflow = prevBodyOverflow || "";
    prevBodyOverflow = null;

    var done = function () {
      wrap.hidden = true;
      wrap.removeEventListener("transitionend", done);
    };
    /* transitionend is not guaranteed - reduced motion removes the transition
       entirely - so it is raced against a timeout rather than relied on. */
    wrap.addEventListener("transitionend", done);
    setTimeout(done, 320);

    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var opener = t.closest("[data-gc-devhelp-open]");
    if (opener) {
      e.preventDefault();
      var id = opener.getAttribute("aria-controls");
      open(id ? document.getElementById(id) : null, opener);
      return;
    }

    if (t.closest("[data-gc-devhelp-close]")) {
      e.preventDefault();
      close();
      return;
    }

    var ask = t.closest("[data-gc-devhelp-ask]");
    if (ask) {
      e.preventDefault();
      close();
      /* gc-product-upsell.js exposes this so the inbox is opened by one route
         rather than every caller re-implementing the shadow-root walk. */
      if (typeof window.gcOpenChat === "function") window.gcOpenChat();
      return;
    }
  });

  document.addEventListener("keydown", function (e) {
    if (!openPanel) return;

    if (e.key === "Escape") {
      e.preventDefault();
      close();
      return;
    }

    if (e.key !== "Tab") return;
    var f = focusables(openPanel);
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();

/* ==========================================================================
   THE THREE-SCREEN GUIDE INSIDE "WHICH MODEL DO I HAVE?"

   The track is a native scroll-snap container, so a swipe is the browser's own
   gesture. Everything here only reads or sets scrollLeft - there is no second
   copy of "which step are we on" that could drift out of step with what is
   actually on screen.
   ========================================================================== */
(function () {
  "use strict";

  function init(guide) {
    if (guide.__gcGuideReady) return;
    guide.__gcGuideReady = true;

    var track = guide.querySelector("[data-gc-guide-track]");
    var slides = [].slice.call(guide.querySelectorAll("[data-gc-guide-slide]"));
    var dots = [].slice.call(guide.querySelectorAll("[data-gc-guide-dot]"));
    var prev = guide.querySelector("[data-gc-guide-prev]");
    var next = guide.querySelector("[data-gc-guide-next]");
    var cap = guide.querySelector("[data-gc-guide-cap]");
    if (!track || !slides.length) return;

    var current = -1;

    /* Both of these work from live rectangles rather than from clientWidth.
       Multiplying an index by clientWidth assumes the container has been laid
       out and that every slide is exactly that wide - and when clientWidth
       comes back as 0, every step resolves to scrollLeft 0 and the buttons
       silently do nothing. Measuring where the slides actually are cannot
       fail that way. */
    function indexFromScroll() {
      var tc = track.getBoundingClientRect();
      var centre = tc.left + tc.width / 2;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var r = slides[i].getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - centre);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var tc = track.getBoundingClientRect();
      var sc = slides[i].getBoundingClientRect();
      var delta = (sc.left + sc.width / 2) - (tc.left + tc.width / 2);
      if (!isFinite(delta)) return;
      track.scrollTo({ left: track.scrollLeft + delta, behavior: "smooth" });
      /* the scroll listener normally drives this, but a zero-distance scroll
         fires no scroll event, so the state is set here too */
      setActive(i);
    }

    /* The fingertip is placed against the row it is pointing at rather than at
       a fixed offset, because the rows move when a label wraps in a language
       with longer words. offsetTop/offsetLeft are relative to .ios, which is
       the nearest positioned ancestor. */
    function placeTap(slide) {
      var tap = slide.querySelector("[data-gc-guide-tap]");
      var row = slide.querySelector("[data-gc-guide-target]");
      var ios = slide.querySelector(".ios");
      if (!tap || !row || !ios) return;

      /* Rectangles, not offsetTop. offsetTop is measured from the nearest
         POSITIONED ancestor, and measured live that turned out to be the
         group the row sits in rather than the phone - so the values came back
         as the row's offset inside its own group (0, 0 and 56) and the
         fingertip landed 218px above the row it was pointing at.
         Rect differences have no such ambiguity. .ios has no border, so its
         padding box - which is what an absolutely positioned child is placed
         against - starts at the same point as its border box. */
      var ir = ios.getBoundingClientRect();
      var rr = row.getBoundingClientRect();
      if (!rr.height) return;   /* still hidden; nothing worth measuring yet */
      tap.style.left = Math.round(rr.left - ir.left + rr.width * 0.74) + "px";
      tap.style.top = Math.round(rr.top - ir.top + rr.height / 2) + "px";
    }

    function setActive(i) {
      if (i === current) return;
      current = i;

      slides.forEach(function (s, n) {
        s.classList.toggle("is-active", n === i);
        /* everything off-screen is hidden from assistive tech, so the panel
           reads as one step at a time rather than three stacked lists */
        s.setAttribute("aria-hidden", n === i ? "false" : "true");
      });
      dots.forEach(function (d, n) {
        d.classList.toggle("is-on", n === i);
        d.setAttribute("aria-selected", n === i ? "true" : "false");
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      if (cap) {
        var t = cap.getAttribute("data-cap-" + (i + 1));
        /* textContent, not innerHTML: these strings are plain text and come
           from a translation file, which is not somewhere HTML should be
           trusted from. */
        if (t) cap.textContent = t;
      }
      placeTap(slides[i]);
    }

    var raf = 0;
    track.addEventListener("scroll", function () {
      if (raf) return;
      raf = setTimeout(function () {
        raf = 0;
        setActive(indexFromScroll());
      }, 60);
    }, { passive: true });

    if (prev) prev.addEventListener("click", function () { goTo(Math.max(0, current - 1)); });
    if (next) next.addEventListener("click", function () { goTo(Math.min(slides.length - 1, current + 1)); });
    dots.forEach(function (d, n) { d.addEventListener("click", function () { goTo(n); }); });

    track.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); goTo(Math.min(slides.length - 1, current + 1)); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); goTo(Math.max(0, current - 1)); }
    });

    /* the phone is laid out in a hidden dialog, so the row positions are only
       real once it has been shown - re-measured on open and on resize */
    guide.__gcGuideSync = function () {
      track.scrollLeft = 0;
      current = -1;
      setActive(0);
      slides.forEach(placeTap);
    };

    var rt = 0;
    window.addEventListener("resize", function () {
      clearTimeout(rt);
      rt = setTimeout(function () { slides.forEach(placeTap); }, 150);
    });

    setActive(0);
  }

  function boot() {
    [].slice.call(document.querySelectorAll("[data-gc-guide]")).forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* when the dialog opens, the guide finally has real dimensions */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest("[data-gc-devhelp-open]")) return;
    setTimeout(function () {
      [].slice.call(document.querySelectorAll("[data-gc-guide]")).forEach(function (g) {
        init(g);
        if (typeof g.__gcGuideSync === "function") g.__gcGuideSync();
      });
    }, 90);
  }, true);
})();
